module.exports = __webpack_public_path__ + "img/shop-icon.32571a16.png";